import { projectScheduleDay } from './scheduleTimezones';
import type { Transport } from '../types';

export interface HomePlan {
  id: string;
  name: string;
  l1Key: string;
  date: string;
  category?: string;
  meal?: string;
  start?: string;
}
interface HomeSlot {
  clock?: { date: string; zone: string; day: string };
  id: string;
  title?: string;
  type?: string;
  start?: string;
  activityId?: string | null;
  chosen?: number;
  options?: { title?: string; shortlistId?: string; category?: string }[];
}
export interface HomeSchedule { days?: { date: string; slots?: HomeSlot[] }[] }

/** Preview the saved day without treating a Shortlist commitment as a placed slot. */
export function homeSchedulePlans(schedule: HomeSchedule | null, date: string, plans: HomePlan[], transports: Transport[] = []) {
  const placed = new Set<string>();
  const byId = new Map(plans.map(plan => [plan.id, plan]));
  const scheduled = projectScheduleDay(schedule?.days?.find(day => day.date === date) || { date, slots: [] }, transports).slots
    .map(slot => {
      const chosen = slot.chosen != null && slot.chosen >= 0 ? slot.options?.[slot.chosen] : undefined;
      const sourceId = slot.activityId || chosen?.shortlistId;
      if (sourceId) placed.add(sourceId);
      const source = sourceId ? byId.get(sourceId) : undefined;
      const l1Key = ({ eat: 'food', meal: 'food', attraction: 'experiences', activity: 'experiences',
        travel: 'transport', free: 'other' } as Record<string, string>)[slot.type || ''] || slot.type || 'other';
      return { ...source, id: slot.id, name: source?.name || chosen?.title || slot.title || 'Scheduled activity',
        l1Key: source?.l1Key || l1Key, category: source?.category || chosen?.category, date, start: slot.start };
    });
  return { scheduled, shortlisted: plans.filter(plan => !placed.has(plan.id)) };
}
